module.exports = __webpack_public_path__ + "static/media/warning.6391ea44.svg";